// eslint-disable-next-line import/no-unresolved
import AppConfig from 'appconfig';
import React from 'react';
import { connect } from 'react-redux';
import withRouter from '../../hoc/withRouter';

import './devenv.scss';

class PageDevEnvSelector extends React.Component {
    createSelector(env) {
        return () => {
            this.onSelectDevEnv(env);
        };
    }

    onSelectDevEnv(env) {
        AppConfig.activeEnvironment = AppConfig.availableEnvs[env];

        this.props.changeEnvironment({
            activeEnvironmentName: AppConfig.activeEnvironment.hubEnvironment,
        });
    }

    render() {
        return (
            <div className="devenv-selector">
                <ul>
                    {Object.keys(AppConfig.availableEnvs).map((env) => {
                        return (
                            <li key={'env' + env} onClick={this.createSelector(env)}>
                                <div className="env-name">{env}</div>
                                <div className="env-detail">{AppConfig.availableEnvs[env].hubUrl}</div>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    uiState: state.uiState,
});

const mapDispatchToProps = {
    changeEnvironment: ({ activeEnvironmentName }) => ({
        type: 'CHANGE_ENVIRONMENT',
        data: { activeEnvironmentName },
    }),
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageDevEnvSelector));
